module.exports = __webpack_public_path__ + "static/media/1.f83bdcfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/minsk/1.jpg
// module id = 227
// module chunks = 0